import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import {
  LINK_TYPE,
  TAX_DEDUCT_COMMON_FIELD,
  TAX_DEDUCT_NNT_FIELD,
  TAX_DEDUCT_TCTTNHAP_FIELD,
  TAX_DEDUCT_TTNCNKTRU_FIELD,
} from "constants/TaxDeductConstant";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import { loopGenerateField } from "helpers/form_helper_license";
import {
  useAdjustTaxDeduct,
  useReplaceTaxDeduct,
} from "hooks/taxDeduct/useTaxDeduct";
import {
  formatTimestampToDate,
  MODE_FORM,
} from "pages/DataFormatInvoice/utils";
import {
  convertDate,
  customViewField,
  initOptionDateLocale,
} from "pages/IssueInvoice/utils";
import PropTypes from "prop-types";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import {
  createTaxDeducts,
  editTaxDeducts,
  getDetailTaxDeducts,
  resetDetailTaxDeducts,
} from "store/actions";
import * as yup from "yup";
import {
  getCurrentKhctu,
  MODE_TAX_DEDUCT_ACTION,
  TYPE_ADJUST_TAX_DEDUCT,
} from "./utils";

const DetailData = props => {
  const {
    isOpen,
    toggle,
    dataDetail,
    t,
    i18n,
    toggleReleaseModal,
    dataConfirmAction,
    showPdfById,
    finalBuReleaseInfo,
  } = props;

  const [optionDateLocale, setOptionDateLocale] =
    useState(initOptionDateLocale);

  const dataFormat = useSelector(state => state.dataFormat);
  const {
    loading: loadingDetail,
    data: detailTaxDeducts,
    error,
  } = dataFormat.detailTaxDeductsData;

  const {
    loading: loadingCreate,
    data: createData,
    error: errorCreateData,
  } = dataFormat.createTaxDeductsData;

  const {
    loading: loadingEdit,
    data: editData,
    error: errorEditData,
  } = dataFormat.editTaxDeductsData;

  const Dashboard = useSelector(state => state.Dashboard);
  const { buStoreHeader, finalBuInfo } = Dashboard;

  const {
    mutate: mutateReplaceTaxDeduct,
    isLoading: isLoadingReplaceTaxDeduct,
  } = useReplaceTaxDeduct({
    onSuccess: response => {
      console.log("onSuccess replace tax deduct", response);
      const { result, error } = response?.data;
      if (result === false) {
        addToast("Tạo chứng từ thay thế thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        const listError = error?.root_id?.map(item => item) || [];
        if (listError.length > 0) {
          addToast(listError.join(", "), {
            appearance: "error",
            autoDismiss: true,
          });
        }
      } else {
        addToast("Tạo chứng từ thay thế thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        setTimeout(() => {
          toggle(true);
        }, 500);
      }
    },
    onError: error => {
      console.log("onError replace tax deduct", error);
    },
  });

  const { mutate: mutateAdjustTaxDeduct, isLoading: isLoadingAdjustTaxDeduct } =
    useAdjustTaxDeduct({
      onSuccess: response => {
        console.log("onSuccess adjust tax deduct", response);
        const { result, error } = response?.data;
        if (result === false) {
          addToast("Tạo chứng từ điều chỉnh thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          const listError = error?.root_id?.map(item => item) || [];
          if (listError.length > 0) {
            addToast(listError.join(", "), {
              appearance: "error",
              autoDismiss: true,
            });
          }
        } else {
          addToast("Tạo chứng từ điều chỉnh thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          setTimeout(() => {
            toggle(true);
          }, 500);
        }
      },
      onError: error => {
        console.log("onError adjust tax deduct", error);
      },
    });

  const setDefaultConfigField = () => {
    const defaultBusinessUnitInfoField = {
      [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_TEN.field]: "ten",
      [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_MST.field]: "mst",
      [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_DCHI.field]: "dchi",
      [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_DCTDTU.field]: "dctdtu",
      [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_SDTHOAI.field]: "sdthoai",
    };
    console.log(
      "🚀 ~ Thông tin chi nhánh/đơn vị phát hành:",
      finalBuReleaseInfo
    );
    if (finalBuReleaseInfo) {
      for (const key in defaultBusinessUnitInfoField) {
        const defaultValue =
          finalBuReleaseInfo[defaultBusinessUnitInfoField[key]];
        if (defaultValue) {
          setValue(key, defaultValue);
        } else {
          setValue(key, "");
        }
      }
    }
    // if (!configField.loadingConfigField) {
    //   setTimeout(() => {
    //     if (modal && modal.current) {
    //       modal.current.scrollTop = 0;
    //     }
    //   });
    // }
  };

  const modal = useRef(null);
  const [disableForm, setDisableForm] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { previewPdfRegisterFile, type, fileDownload, fileDownloadName } =
    dataFormat;
  const { addToast } = useToasts();
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  useEffect(() => {
    if (
      previewPdfRegisterFile &&
      previewPdfRegisterFile.data &&
      previewPdfRegisterFile.typePreview !== "popupType"
    ) {
      const link = document.createElement("a");
      link.href = previewPdfRegisterFile.data;
      link.setAttribute("download", "Invoice.pdf");
      document.body.appendChild(link);
      link.click();
      console.log(previewPdfRegisterFile, "previewPdfRegisterFile");
      addToast("Tải xuống thành công", {
        appearance: "success",
        autoDismiss: true,
      });
    } else {
      if (previewPdfRegisterFile && previewPdfRegisterFile.error) {
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    }
  }, [previewPdfRegisterFile]);
  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  const dispatch = useDispatch();

  const FIRST_BLOCK = [
    TAX_DEDUCT_COMMON_FIELD.TTCHUNG_THDON,
    TAX_DEDUCT_COMMON_FIELD.TTCHUNG_MSCTU,
    TAX_DEDUCT_COMMON_FIELD.TTCHUNG_NLAP,
    TAX_DEDUCT_COMMON_FIELD.TTCHUNG_KHCTU,
    TAX_DEDUCT_COMMON_FIELD.TTCHUNG_SCTU,
    TAX_DEDUCT_COMMON_FIELD.SIGNING_DATE,
  ];

  const SECOND_BLOCK = [
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_TEN,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_MST,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_DCHI,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_SDTHOAI,
  ];

  const THIRD_BLOCK = [
    TAX_DEDUCT_NNT_FIELD.NNT_TEN,
    TAX_DEDUCT_NNT_FIELD.NNT_MST,
    TAX_DEDUCT_NNT_FIELD.NNT_CCCDAN,
    TAX_DEDUCT_NNT_FIELD.NNT_DCHI,
    TAX_DEDUCT_NNT_FIELD.NNT_QTICH,
    // TAX_DEDUCT_NNT_FIELD.NNT_NGCCMND,
    TAX_DEDUCT_NNT_FIELD.NNT_CNCTRU,
    TAX_DEDUCT_NNT_FIELD.NNT_SDTHOAI,
    // TAX_DEDUCT_NNT_FIELD.NNT_NCCMND,
    TAX_DEDUCT_NNT_FIELD.NNT_DCTDTU,
  ];

  const FOUR_BLOCK = [
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_KTNHAP,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_BHIEM,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTHIEN,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTHANG,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_DTHANG,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_NAM,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTNCTHUE,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTNTTHUE,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_STHUE,
  ];

  const objSchema = {};
  const initDefaultValues = {};
  const TOTAL_FIELD = [
    ...FIRST_BLOCK,
    ...SECOND_BLOCK,
    ...THIRD_BLOCK,
    ...FOUR_BLOCK,
  ];

  TOTAL_FIELD.map(item => {
    const itemField = item;
    switch (itemField.type) {
      case "text":
        initDefaultValues[itemField.field] = itemField.defaultValue || "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.char_max", { max: itemField.max })
          );
        }
        if (itemField.isCCCD) {
          // CCCD: 12 số
          // Hộ chiếu: 6-20 ký tự chữ/số
          // Không cho phép CMND: 9 số
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "identity-format",
            "Vui lòng nhập CCCD 12 số hoặc Hộ chiếu 6-20 ký tự chữ/số. Không cho phép CMND 9 số",
            val => {
              const value = (val ?? "").trim();

              if (value.length === 0) {
                return true;
              }

              const isCmnd = /^\d{9}$/.test(value);
              if (isCmnd) {
                return false;
              }

              const isCccd = /^\d{12}$/.test(value);
              const isPassport = /^[A-Za-z0-9]{6,20}$/.test(value);

              return isCccd || isPassport;
            }
          );
        }
        if (itemField.isEmail) {
          objSchema[itemField.field] = objSchema[itemField.field].email(
            t("form.validate.invalid", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.isTaxCode) {
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "len",
            "Vui lòng nhập tối đa 14 ký tự",
            val => val.length === 0 || val.length <= 14
          );
        }
        if (itemField.isKHHD) {
          //   objSchema[itemField.field] = objSchema[itemField.field].matches(
          //     /^[A]*$/,
          //     "Vui lòng chỉ nhập các ký tự (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)"
          //   );
          // objSchema[itemField.field] = objSchema[itemField.field].test(
          //   "len",
          //   "Vui lòng nhập 2 ký tự cuối (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)",
          //   val => {
          //     return val.length === 6;
          //   }
          // );
          initDefaultValues[itemField.field] = undefined;

          objSchema[itemField.field] = objSchema[itemField.field];
          objSchema[itemField.field] = yup.object();
          if (itemField.required) {
            objSchema[itemField.field] = objSchema[itemField.field].required(
              t("form.validate.select", { title: t(`form.${itemField.field}`) })
            );
          }
        }
        // Nếu không nhập MST thì phải nhập CMND
        if (
          itemField.field === TAX_DEDUCT_NNT_FIELD.NNT_CCCDAN.field
          // ||
          // itemField.field === TAX_DEDUCT_NNT_FIELD.NNT_NCCMND.field
        ) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            TAX_DEDUCT_NNT_FIELD.NNT_MST.field,
            {
              is: mst => mst.length === 0,
              then: yup.string().required(
                t("form.validate.required", {
                  title: t(`form.${itemField.field}`),
                })
              ),
            }
          );
        }
        //
        break;
      case "number":
        initDefaultValues[itemField.field] = 0;

        objSchema[itemField.field] = yup.number();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }

        // objSchema[itemField.field] = objSchema[itemField.field].matches(
        //   /^[0-9]+$/,
        //   t("form.validate.integer")
        // );

        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.integer_max", { max: itemField.max })
          );
        }
        break;
      case "select":
        initDefaultValues[itemField.field] =
          itemField.defaultValue || undefined;
        objSchema[itemField.field] = yup.object().nullable();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        // TTNCNKTRU_DTHANG >= TTNCNKTRU_DTHANG
        if (
          itemField.field === TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_DTHANG.field
        ) {
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "isLarger",
            "Phải lớn hơn hoặc bằng tháng bắt đầu trả thu nhập",
            (data, testContext) => {
              const TTHANG =
                testContext.parent[
                  TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTHANG.field
                ]?.value;
              const DTHANG = data?.value;
              if (DTHANG < TTHANG) {
                return false;
              }
              return true;
            }
          );
        }
        break;
      case "date":
        initDefaultValues[itemField.field] = itemField.defaultValue || [];
        objSchema[itemField.field] = yup.array();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].min(
            1,
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        // Nếu không nhập MST thì phải nhập CMND
        if (itemField.field === TAX_DEDUCT_NNT_FIELD.NNT_CCCDAN.field) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            TAX_DEDUCT_NNT_FIELD.NNT_MST.field,
            {
              is: mst => mst.length === 0,
              then: yup.array().min(
                1,
                t("form.validate.select", {
                  title: t(`form.${itemField.field}`),
                })
              ),
            }
          );
        }
        break;
      case "object":
        objSchema[itemField.field] = yup.mixed().nullable();
        break;
      default:
        break;
    }
  });

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setDefaultConfigField();
      });
      if (dataDetail?.khctu) {
        setTimeout(() => {
          setValue(
            TAX_DEDUCT_COMMON_FIELD.TTCHUNG_KHCTU.field,
            dataDetail?.khctu
          );
        });
      }
      checkDisableForm();
      reset();
      if (dataDetail?.id) {
        dispatch(getDetailTaxDeducts(dataDetail.id));
      } else {
      }
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
          //   setFocus(COMMON_FIELD.TNNT.field);
        }
      });
    } else {
      dispatch(resetDetailTaxDeducts());
    }
  }, [isOpen]);

  const checkDisableForm = () => {
    if (dataDetail?.mode === MODE_FORM.VIEW) {
      setDisableForm(true);
    } else {
      setDisableForm(false);
    }
  };

  // Custom set default value
  const setDefaultValue = (FIELDS, isTimeOut = false) => {
    console.log("🚀 ~ setDefaultValue ~ detailTaxDeducts:", detailTaxDeducts);
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      let finalValue = detailTaxDeducts[finalKey];
      if (finalValue) {
        switch (type) {
          case "select":
            const option = OPTION_GROUP[finalKey];
            const valueSelect = option.find(item => item.value === finalValue);
            if (valueSelect) {
              setValue(finalKey, valueSelect);
            } else if (finalValue) {
              setValue(finalKey, {
                value: finalValue,
                label: finalValue,
              });
            }
            break;
          case "text":
            switch (finalKey) {
              // case TAX_DEDUCT_COMMON_FIELD.TTCHUNG_KHCTU.field:
              //   finalValue =
              //     detailTaxDeducts[
              //       TAX_DEDUCT_COMMON_FIELD.TTCHUNG_MSCTU.field
              //     ] +
              //     " " +
              //     detailTaxDeducts[finalKey];

              //   break;
              case TAX_DEDUCT_COMMON_FIELD.TTCHUNG_SCTU.field:
                // Nếu đang tạo CTKT thay thế/điều chỉnh thì hiển thị chờ cấp số
                if (dataConfirmAction) {
                  finalValue = "Chờ cấp số";
                } else {
                  finalValue =
                    Number(finalValue) === 0 || finalValue === null
                      ? "Chờ cấp số"
                      : finalValue;
                }
                break;
              default:
                break;
            }
            setValue(finalKey, finalValue);
            break;
          case "date":
            const date = formatTimestampToDate(finalValue);
            setValue(finalKey, [date]);
            break;
        }
      }
    }
  };

  const schema = yup.object().shape(objSchema);
  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...initDefaultValues,
    },
  });

  const OPTION_CNCTRU = [
    {
      value: 1,
      label: "Cư trú",
    },
    {
      value: 0,
      label: "Không cư trú",
    },
  ];

  const OPTION_THANG = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(item => ({
    value: item,
    label: `Tháng ${item}`,
  }));

  const OPTION_GROUP = {
    [TAX_DEDUCT_NNT_FIELD.NNT_CNCTRU.field]: OPTION_CNCTRU,
    [TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTHANG.field]: OPTION_THANG,
    [TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_DTHANG.field]: OPTION_THANG,
  };

  useEffect(() => {
    if (errors) {
      console.log(
        "🚀 ~ file: DetailData.js ~ line 572 ~ useEffect ~ errors:",
        errors
      );
    }
  }, [errors]);

  const submitForm = values => {
    const finalData = formatData(values);
    finalData.ttchung_khctu = getCurrentKhctu();
    delete finalData?.ttchung_sctu;
    delete finalData?.signing_date;
    //
    // Thay thế/điều chỉnh CTKT
    if (dataConfirmAction) {
      console.log("🚀 ~ submitForm ~ dataConfirmAction:", dataConfirmAction);
      const data = {
        root_id: dataDetail.id,
        adjust_mod: dataConfirmAction.typeAdjust,
        tax_deduct_detail: finalData,
        gchu: "",
        attach_ids: [],
      };
      console.log("🚀 ~ data create replace/adjust:", data);
      switch (dataConfirmAction.mode) {
        case MODE_TAX_DEDUCT_ACTION.REPLACE:
          mutateReplaceTaxDeduct(data);
          break;
        case MODE_TAX_DEDUCT_ACTION.ADJUST:
          mutateAdjustTaxDeduct(data);
          break;
        default:
          break;
      }
      return;
    }
    if (dataDetail.id) {
      dispatch(editTaxDeducts(finalData, dataDetail.id));
    } else {
      dispatch(createTaxDeducts(finalData));
    }
  };

  const formatData = values => {
    const finalData = {};

    TOTAL_FIELD.map(item => {
      const itemField = item;
      const valueField = values[itemField.field];
      switch (itemField.type) {
        case "object":
          finalData[itemField.field] = valueField;
          break;
        case "text":
          finalData[itemField.field] = valueField || "";
          break;
        case "number":
          finalData[itemField.field] = Number(valueField);
          break;
        case "select":
          finalData[itemField.field] = valueField?.value
            ? valueField.value
            : "";
          break;
        case "date":
          finalData[itemField.field] = convertDate(valueField[0], "YYYY-MM-DD");
          break;

        default:
          break;
      }
    });

    return finalData;
  };

  // Field không được nhập điều chỉnh CTKT
  const FIELD_DISABLE_WHEN_ADJUST_INCREASE_DECREASE = [
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_TEN.field,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_MST.field,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_DCHI.field,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_SDTHOAI.field,

    TAX_DEDUCT_NNT_FIELD.NNT_TEN.field,
    TAX_DEDUCT_NNT_FIELD.NNT_MST.field,
    TAX_DEDUCT_NNT_FIELD.NNT_CCCDAN.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_DCHI.field,
    TAX_DEDUCT_NNT_FIELD.NNT_QTICH.field,
    TAX_DEDUCT_NNT_FIELD.NNT_CNCTRU.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_SDTHOAI.field,
    TAX_DEDUCT_NNT_FIELD.NNT_DCTDTU.field,

    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_KTNHAP.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTHANG.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_DTHANG.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_NAM.field,
  ];

  const FIELD_DISABLE_WHEN_ADJUST_CHANGE_INFO = [
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_TEN.field,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_MST.field,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_DCHI.field,
    TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_SDTHOAI.field,

    // TAX_DEDUCT_NNT_FIELD.NNT_TEN.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_MST.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_CCCDAN.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_DCHI.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_QTICH.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_CNCTRU.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_SDTHOAI.field,
    // TAX_DEDUCT_NNT_FIELD.NNT_DCTDTU.field,

    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_BHIEM.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTHIEN.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTNCTHUE.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTNTTHUE.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_STHUE.field,
    TAX_DEDUCT_TTNCNKTRU_FIELD.TTNCNKTRU_TTHIEN.field,
  ];

  // Field không được nhập khi thay thế/điều chỉnh CTKT
  const FIELD_DISALBE_BY_MODE = {
    [MODE_TAX_DEDUCT_ACTION.REPLACE]: [],
    [`${MODE_TAX_DEDUCT_ACTION.ADJUST_INCREASE}`]: [
      ...FIELD_DISABLE_WHEN_ADJUST_INCREASE_DECREASE,
    ],
    [`${MODE_TAX_DEDUCT_ACTION.ADJUST_DECREASE}`]: [
      ...FIELD_DISABLE_WHEN_ADJUST_INCREASE_DECREASE,
    ],
    [`${MODE_TAX_DEDUCT_ACTION.ADJUST_CHANGE_INFO}`]: [
      ...FIELD_DISABLE_WHEN_ADJUST_CHANGE_INFO,
    ],
  };

  const fieldsDisableByMode = useMemo(() => {
    if (!isOpen) return [];
    let disableFields = [];
    if (dataConfirmAction) {
      let modeCheck = dataConfirmAction?.mode;
      if (dataConfirmAction?.typeAdjust) {
        modeCheck = `${modeCheck}_${dataConfirmAction?.typeAdjust}`;
      }
      disableFields = FIELD_DISALBE_BY_MODE[modeCheck];
      console.log(
        "🚀 ~ fieldsDisableByMode ~ dataConfirmAction modeCheck:",
        modeCheck
      );
    } else if (detailTaxDeducts) {
      let modeCheck = "";
      const { link_type, adjust_mod } = detailTaxDeducts;
      switch (link_type) {
        case LINK_TYPE.CHILD_REPLACE:
          modeCheck = MODE_TAX_DEDUCT_ACTION.REPLACE;
          break;
        case LINK_TYPE.CHILD_ADJUST:
          modeCheck = `${MODE_TAX_DEDUCT_ACTION.ADJUST}_${adjust_mod}`;
          break;
        default:
          break;
      }
      disableFields = FIELD_DISALBE_BY_MODE[modeCheck] || [];
      console.log(
        "🚀 ~ fieldsDisableByMode ~ detailTaxDeducts modeCheck:",
        modeCheck
      );
    }
    console.log("🚀 ~ fieldsDisableByMode ~ disableFields:", disableFields);
    return disableFields || [];
  }, [dataConfirmAction, isOpen, detailTaxDeducts]);

  const generalField = value => {
    if (!isOpen) return;
    let placeholder = "";
    if (value.isTaxCode) {
      placeholder = "XXXXXXXXXX-XXX (Tối đa 14 kí tự)";
    } else {
      placeholder = t("placeholder.enter", {
        title: t(`form.${value.field}`),
      });
    }
    const disable =
      disableForm ||
      loadingCreate ||
      loadingEdit ||
      isLoadingReplaceTaxDeduct ||
      isLoadingAdjustTaxDeduct ||
      fieldsDisableByMode.includes(value.field);

    // Điều chỉnh giảm thì cho phép nhập số âm
    let isAdjustDecrease = false;
    if (detailTaxDeducts) {
      const { link_type, adjust_mod } = detailTaxDeducts;
      isAdjustDecrease =
        link_type === LINK_TYPE.CHILD_ADJUST &&
        adjust_mod === TYPE_ADJUST_TAX_DEDUCT.DECREASE;
    }
    if (dataConfirmAction) {
      isAdjustDecrease =
        dataConfirmAction?.mode === MODE_TAX_DEDUCT_ACTION.ADJUST &&
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_TAX_DEDUCT.DECREASE;
    }
    if (isAdjustDecrease) {
      value.allowNegative = true;
    }

    return loopGenerateField({
      item: value,
      label: t(`form.${value.field}`),
      placeholder,
      errors,
      touchedFields,
      register,
      control,
      OPTION_GROUP,
      optionDateLocale,
      onChangeHandle,
      disableForm: disable,
    });
  };

  const onChangeHandle = (data, field) => {
    switch (field) {
      case "CQTQLY":
        setValue(CTU_FIELD.MCQTQLY.field, data?.code, {
          shouldValidate: true,
        });
        break;
    }
  };

  useEffect(() => {
    if (detailTaxDeducts && isOpen) {
      setDefaultValue(TOTAL_FIELD);
    }
  }, [detailTaxDeducts]);

  const getTextLinkTaxDeduct = useCallback(() => {
    if (!isOpen || !detailTaxDeducts) return;
    console.log("🚀 ~ getTextLinkTaxDeduct :");
    console.log({ dataConfirmAction, detailTaxDeducts });
    let title = "";
    let id = null;
    // Tạo CTKT thay thế/điều chỉnh
    if (dataConfirmAction) {
      const today = new Date(Number(dataConfirmAction.nlap) * 1000);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      const infoTaxDeduct = `Mẫu số: ${dataConfirmAction.pattern}, Ký hiệu: ${dataConfirmAction.serial}, Số: ${dataConfirmAction.invoiceNo}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
      switch (dataConfirmAction.mode) {
        case MODE_TAX_DEDUCT_ACTION.REPLACE:
          title = `Thay thế cho CTKT ${infoTaxDeduct}`;
          break;
        case MODE_TAX_DEDUCT_ACTION.ADJUST:
          let titleAdjust = "";
          switch (dataConfirmAction.typeAdjust) {
            case TYPE_ADJUST_TAX_DEDUCT.INCREASE:
              titleAdjust = `tăng`;
              break;
            case TYPE_ADJUST_TAX_DEDUCT.DECREASE:
              titleAdjust = `giảm`;
              break;
            case TYPE_ADJUST_TAX_DEDUCT.CHANGE_INFO:
              titleAdjust = `thông tin`;
              break;
            default:
              break;
          }
          title = `Điều chỉnh ${titleAdjust} cho CTKT ${infoTaxDeduct}`;
        default:
          break;
      }
      id = dataConfirmAction.id;
    } else {
      // Cập nhật thông tin CTKT thay thế/điều chỉnh (CTKT con)
      if (detailTaxDeducts?.root) {
        const today = new Date(detailTaxDeducts?.root.ttchung_nlap * 1000);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        const infoTaxDeduct = `Mẫu số: ${detailTaxDeducts?.root.ttchung_msctu}, Ký hiệu: ${detailTaxDeducts?.root.ttchung_khctu}, Số: ${detailTaxDeducts?.root.ttchung_sctu}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
        switch (Number(detailTaxDeducts?.ttctlquan_tcctu)) {
          case 1:
            title = `Thay thế cho CTKT ${infoTaxDeduct}`;
            break;
          case 2:
            let titleAdjust = "";
            switch (Number(detailTaxDeducts?.adjust_mod)) {
              case 1:
                titleAdjust = `tăng`;
                break;
              case 2:
                titleAdjust = `giảm`;
                break;
              case 3:
                titleAdjust = `thông tin`;
                break;
              default:
                break;
            }
            title = `Điều chỉnh ${titleAdjust} cho CTKT ${infoTaxDeduct}`;
            break;
          default:
            break;
        }
        id = detailTaxDeducts?.root.id;
      }
      // Bị thay thế/ điều chỉnh (CTKT cha)
      if (detailTaxDeducts?.child?.length > 0) {
        const lastChild = detailTaxDeducts?.child.sort(
          (a, b) => b.id - a.id
        )[0];
        const today = new Date(lastChild?.ttchung_nlap * 1000);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        id = lastChild?.id;
        const infoTaxDeduct = `Mẫu số: ${lastChild?.ttchung_msctu}, Ký hiệu: ${
          lastChild?.ttchung_khctu
        }, Số: ${
          lastChild?.ttchung_sctu || "Chưa có"
        }, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
        switch (Number(lastChild?.ttctlquan_tcctu)) {
          case 1:
            title = `Bị thay thế bởi CTKT ${infoTaxDeduct}`;
            break;
          case 2:
            title = `Bị điều chỉnh bởi CTKT ${infoTaxDeduct}`;
            break;
          default:
            break;
        }
      }
    }

    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (id) {
            showPdfById(id);
          }
        }}
        className="text-danger text-center font-size-20"
      >
        {title}
      </div>
    );
  }, [dataConfirmAction, detailTaxDeducts, showPdfById, isOpen]);

  const getLabelButtonSubmit = useCallback(() => {
    if (!isOpen) return;
    let title = "";
    if (dataConfirmAction) {
      // Thay thế /điều chỉnh CTKT
      switch (dataConfirmAction.mode) {
        case MODE_TAX_DEDUCT_ACTION.REPLACE:
          title = "Tạo CTKT thay thế";
          break;
        case MODE_TAX_DEDUCT_ACTION.ADJUST:
          switch (dataConfirmAction.typeAdjust) {
            case TYPE_ADJUST_TAX_DEDUCT.INCREASE:
              title = "Tạo CTKT điều chỉnh tăng";
              break;
            case TYPE_ADJUST_TAX_DEDUCT.DECREASE:
              title = "Tạo CTKT điều chỉnh giảm";
              break;
            case TYPE_ADJUST_TAX_DEDUCT.CHANGE_INFO:
              title = "Tạo CTKT điều chỉnh thông tin";
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    } else {
      return t(`button.${dataDetail?.mode}`);
    }
    return title;
  }, [isOpen, dataConfirmAction, dataDetail]);

  return (
    <Modal
      size="lg"
      contentClassName="detail-data-format"
      style={{ maxWidth: "95%" }}
      //   contentClassName="custom-modal-style"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                style={{
                  maxHeight: "79vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div>{getTextLinkTaxDeduct()}</div>
                <Row className="row-cols-1 row-cols-md-4 mt-2">
                  <Col style={{ marginRight: "121px" }}></Col>
                  {Object.entries(
                    customViewField([
                      FIRST_BLOCK[0],
                      FIRST_BLOCK[3],
                      FIRST_BLOCK[1],
                    ])
                  ).map(([key, value]) => {
                    return generalField(value);
                  })}
                </Row>
                <Row className="row-cols-1 row-cols-md-4">
                  <Col style={{ marginRight: "121px" }}></Col>
                  {Object.entries(
                    customViewField([
                      FIRST_BLOCK[2],
                      FIRST_BLOCK[4],
                      detailTaxDeducts?.[
                        TAX_DEDUCT_COMMON_FIELD.SIGNING_DATE.field
                      ]
                        ? FIRST_BLOCK[5]
                        : {},
                    ])
                  ).map(([key, value]) => {
                    return generalField(value);
                  })}
                </Row>
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> {t("title.tcttnhap")}</strong>
                </div>
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-2">
                      {Object.entries(
                        customViewField([SECOND_BLOCK[0], SECOND_BLOCK[1]])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-2">
                      {Object.entries(
                        customViewField([SECOND_BLOCK[2], SECOND_BLOCK[3]])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                  </CardBody>
                </Card>
                <div className="custom-form-heading d-flex align-items-center">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> {t("title.nnt")} </strong>
                </div>

                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          THIRD_BLOCK[0],
                          THIRD_BLOCK[1],
                          THIRD_BLOCK[2],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          THIRD_BLOCK[3],
                          THIRD_BLOCK[4],
                          THIRD_BLOCK[5],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([THIRD_BLOCK[6], THIRD_BLOCK[7]])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    {/* <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([THIRD_BLOCK[8], THIRD_BLOCK[9]])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                      <Col></Col>
                    </Row> */}
                  </CardBody>
                </Card>
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> {t("title.ttncnktru")}</strong>
                </div>
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1">
                      {Object.entries(customViewField([FOUR_BLOCK[0]])).map(
                        ([key, value]) => {
                          return generalField(value);
                        }
                      )}
                    </Row>
                    <Row className="row-cols-1">
                      {Object.entries(customViewField([FOUR_BLOCK[1]])).map(
                        ([key, value]) => {
                          return generalField(value);
                        }
                      )}
                    </Row>
                    <Row className="row-cols-1">
                      {Object.entries(customViewField([FOUR_BLOCK[2]])).map(
                        ([key, value]) => {
                          return generalField(value);
                        }
                      )}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          FOUR_BLOCK[3],
                          FOUR_BLOCK[4],
                          FOUR_BLOCK[5],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1">
                      {Object.entries(customViewField([FOUR_BLOCK[6]])).map(
                        ([key, value]) => {
                          return generalField(value);
                        }
                      )}
                    </Row>
                    <Row className="row-cols-1">
                      {Object.entries(customViewField([FOUR_BLOCK[7]])).map(
                        ([key, value]) => {
                          return generalField(value);
                        }
                      )}
                    </Row>
                    <Row className="row-cols-1">
                      {Object.entries(customViewField([FOUR_BLOCK[8]])).map(
                        ([key, value]) => {
                          return generalField(value);
                        }
                      )}
                    </Row>
                  </CardBody>
                </Card>
              </div>
            </ModalBody>
            <ModalFooter>
              <React.Fragment>
                {(dataDetail?.mode === MODE_FORM.ADD ||
                  dataDetail?.mode === MODE_FORM.EDIT) && (
                  <Button
                    type="button"
                    color={
                      dataDetail?.mode === MODE_FORM.ADD ? "primary" : "success"
                    }
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      isLoadingReplaceTaxDeduct ||
                      isLoadingAdjustTaxDeduct
                    }
                    onClick={handleSubmit(submitForm)}
                  >
                    <i className="fas fa-save label-icon"></i>
                    {getLabelButtonSubmit()}
                  </Button>
                )}
              </React.Fragment>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailData.propTypes = {
  toggle: PropTypes.func,
  toggleReleaseModal: PropTypes.func,
  isOpen: PropTypes.bool,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  i18n: PropTypes.any,
  showPdfById: PropTypes.func,
  dataConfirmAction: PropTypes.object,
  finalBuReleaseInfo: PropTypes.object,
};

export default DetailData;
